<template>
  <div class="">
    <h2 class="text-primary text-center fw-bolder mb-5 mt-3">Login Account</h2>
    <form action="" class="row justify-content-center" @submit.prevent="loginAccount">
      <div class="col-md-10 col-12">
        <p class="text-danger fw-bold mb-2 text-center" v-if="errorMessage">{{ errorMessage }}</p>
        <div class="mb-3">
          <label for="email" class="form-label">Email Address</label>
          <input type="email" class="form-control" v-model="inputLoginEmail"
                 id="email" placeholder="@gmail.com">
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Password</label>
          <input type="password" class="form-control" v-model="inputLoginPassword"
                 id="password" placeholder="********">
        </div>
        <button class="btn btn-outline-primary float-end mb-3">Login</button>
      </div>
    </form>
  </div>
</template>

<script>
import {ref} from "vue";
import {auth} from "@/firebase/config";
import useSignIn from "@/composables/useSignIn";

export default {
  name: "Login",
  setup(props, context){
    let inputLoginEmail = ref("");
    let inputLoginPassword = ref("");

    let { errorMessage, signIn} = useSignIn();

    let loginAccount = async ()=>{
      let res = await signIn(inputLoginEmail.value, inputLoginPassword.value);
      if (res){
        console.log(res.user);
        context.emit("goToChatRoom");
      }else {
        console.log(errorMessage.value);
      }
    }

    return {inputLoginEmail, inputLoginPassword, loginAccount, errorMessage};
  }
}
</script>

<style scoped>

</style>